import { PodcastEpisodeListType } from '@nimey/podcast-global-entity';
import { EpisodeList, ListLayout } from './episode';


export const RecentEpisodesWithAbo = (props: { limit?: number }) => {
  return <EpisodeList layout={ListLayout.LIST} listType={PodcastEpisodeListType.USER_ABO_RECENT} {...props} title='episode.list.recent-abo.title' />
}